import { render, staticRenderFns } from "./OsiguLogo.vue?vue&type=template&id=a474c924&scoped=true&"
import script from "./OsiguLogo.vue?vue&type=script&lang=js&"
export * from "./OsiguLogo.vue?vue&type=script&lang=js&"
import style0 from "./OsiguLogo.vue?vue&type=style&index=0&id=a474c924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a474c924",
  null
  
)

export default component.exports